import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve successfully implemented advanced predictive models—such as early warning
                systems and portfolio risk automation—across various organizations. Can you walk us
                through one of the most impactful risk analytics solutions you've introduced,
                particularly at QNB or in a previous role?
              </strong>
            </h5>

            <h5 className="text-white">
              Well, there are quite many based on different Risk Management requirements. We have
              recently implemented a Risk Appetite monitoring tool which provides complete
              automation between international branches and the Head Office. There are many other
              tools in the areas of Credit Risk, ALM, Market Risk, Liquidity Risk & Portfolio
              Management.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Digital transformation in risk is complex, especially in regulated environments.
                Your work spans automation, 360-degree customer risk views, and dashboard creation.
                In your experience leading digital risk transformations, what are the most critical
                enablers and roadblocks when embedding automation and analytics into traditional
                risk functions?
              </strong>
            </h5>
            <h5 className="text-white">
              Digital Transformation always comes with a Change Management process. This includes
              Stakeholder engagement, ownership and willingness to accept this change. Data
              governance and management itself is a very difficult task. For every tool
              implementation, data reliability is always the most challenging part, but once the
              technical and functional teams are fully aligned with respect to the ultimate
              objective, then things become easier.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve created systems to estimate risk scoring and probability of default in
                low-default portfolios using actuarial techniques. How do you approach credit
                portfolio management in low-default or complex environments where data may be sparse
                or skewed?
              </strong>
            </h5>
            <h5 className="text-white">
              I wrote a paper in 2012 on this topic which was published by top Actuarial bodies.
              This method provides banks with low default portfolios a way to calculate reliable
              probability of defaults. However, you need some in-depth knowledge of Actuarial
              Science if you want to implement this. Many Risk Managers in the world are using our
              model to calculate PDs for LDPs.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Leading risk transformations often involve coordination across risk, finance, IT,
                and regulatory teams. Having managed projects across multiple disciplines—like IT
                integration, M&A, and regulatory reporting—how do you align stakeholders with
                diverse objectives, especially in fast-paced or high-risk initiatives?
              </strong>
            </h5>
            <h5 className="text-white">
              As a product owner, this is always the most challenging part. However, if the
              requirements are coming from the regulator or from the senior management then
              stakeholder’s management becomes easier. The ultimate key to success is to align all
              the parties with respect to the end user expectations, objective of the project, all
              the challenges which are faced during this journey and to drive the project in the
              best possible optimized way.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve conducted global training and contributed to professional risk literature.
                You’ve contributed significantly to risk knowledge through training and academic
                research. In your view, what role does continuous education and thought leadership
                play in elevating risk maturity within banks?
              </strong>
            </h5>
            <h5 className="text-white">
              Risk Management is a fast moving field where there is always something new to learn.
              Particularly, if you merge Risk Management and IT, then this even becomes more
              interesting. Nowadays, while we are living in the era of Artificial Intelligence,
              continuous progression is the need of hour. In the modern era, Risk Management is
              gelled with the upto date knowledge of IT, Data Governance, Artificial Intelligence &
              Project Management.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
